import React, { useRef } from 'react';
import ModalsEnum from '../enums/modal.enum';
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../redux/modal.slice";
import UploadAndGenerateModal from "./UploadAndGenerateModal";
import GenerateYourQuizModal from "./GenerateYourQuizModal";
import QuizQuestionsModal from './QuizQuestionsModal';
import LoadingModal from './LoadingModal';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import ConfirmCancelationModal from './ConfirmCancelationModal';
import PauseSubscriptionModal from './PauseSubscriptionModal';
import LimitReachedModal from './LimitReachedModal';
import SubscriptionCanceledModal from './SubscriptionCanceledModal';
import AmbassadorModal from './AmbassadorModal';
import InvitationModal from './InvitationModal';

const getModal = ({ modalId, modalData }) => {
    switch (modalId) {
        case ModalsEnum.UPLOAD_AND_GENERATE_MODAL:
            return <UploadAndGenerateModal />;
        case ModalsEnum.GENERATE_YOUR_QUIZ_MODAL:
            return <GenerateYourQuizModal modalData={modalData} />;
        case ModalsEnum.QUIZ_QUESTIONS_MODAL:
            return <QuizQuestionsModal modalData={modalData} />;
        case ModalsEnum.LOADING_MODAL:
                return <LoadingModal modalData={modalData} />;
        case ModalsEnum.CANCEL_SUBSCRIPTION_MODAL:
            return <CancelSubscriptionModal modalData={modalData} />;
        case ModalsEnum.CONFIRM_CANCELATION_MODAL:
            return <ConfirmCancelationModal modalData={modalData} />;
        case ModalsEnum.PAUSE_SUBSCRIPTION_MODAL:
            return <PauseSubscriptionModal modalData={modalData} />;
        case ModalsEnum.LIMIT_REACHED_MODAL:
            return <LimitReachedModal modalData={modalData} />;
        case ModalsEnum.SUBSCRIPTION_CANCELED_MODAL:
            return <SubscriptionCanceledModal modalData={modalData} />;
        case ModalsEnum.AMBASSADOR_MODAL:
            return <AmbassadorModal modalData={modalData} />;
        case ModalsEnum.INVITATION_MODAL:
            return <InvitationModal modalData={modalData} />;
        default:return <></>;
    }
};


const Modal = (props) => {
    const modalClassName = useSelector((state) => state.modal?.modalData[0]?.className);
    const closeRef = useRef(null);
    const dispatch = useDispatch();

    const handleBgCloseModal = () => {
        dispatch(closeModal());
    }

    return (
        <div className={`modal`}>
            <div className="modal-background" onClick={handleBgCloseModal} />
            <div className={`modal-inner ${modalClassName || ''}`} ref={closeRef}>
                {getModal(props)}
            </div>
        </div>
    );
};

export default Modal;
